import './add-apn-modal.scss';
import React, {useState} from "react";
import {observer} from "mobx-react-lite";
import CustomModal from "../../../../shared/custom-modal/custom-modal";
import {Button, Select, Tooltip} from "antd";
import {v4 as uuidv4} from "uuid";
import {ReactComponent as Delete} from '../../../../../assets/svg/delete.svg';
import {ReactComponent as Error} from '../../../../../assets/svg/error.svg';
import {useStores} from "../../../../store";

interface AddApnModalProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    saveApn: ({shortName, apnFamily, selectedCategory}) => void;
}

export const AddApnModal: React.FunctionComponent<AddApnModalProps> = observer(({isOpen, setIsOpen, saveApn}) => {
    const {adminStore} = useStores();
    const [mccMncList, setMccMncList] = useState([{id: uuidv4(), mcc: '', mnc: ''}]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [shortName, setShortName] = useState('');
    const [apnFamily, setApnFamily] = useState('');
    const categoryOptions = [{label: 'Unknown', value: null},
        {label: 'Wi-Fi/Infotainment', value: 'wifi_info'},
        {label: 'Telematics', value: 'telematics'},
        {label: 'Infotainment', value: 'infotainment'}];
    const mccOptions = [{label: 310, value: 310}, {label: 311, value: 311}, {label: 312, value: 312},
        {label: 313, value: 313}, {label: 314, value: 314}, {label: 334, value: 334}];


    const handleOk = () => {
        saveApn({shortName, apnFamily, selectedCategory})
        setIsOpen(false);
    };

    const handleCancel = () => {
        setIsOpen(false);
    };

    function onDeleteClick(index: number) {
        setMccMncList(mccMncList.filter((_, i) => i !== index));
    }

    const handleMccMncChange = (index: number, value: string, field: string) => {
        const newList = [...mccMncList];
        newList[index][field] = value;
        setMccMncList(newList);
    };

    function onGenerateClick() {
        setApnFamily(`${shortName},${
            mccMncList
                .filter(item => item.mcc && item.mnc)
                .map(item => `${shortName}.mnc${item.mnc}.mcc${item.mcc}.gprs`)
                .join(',')}`
        );
    }

    function onApnFamilyInput(e) {
        const target = e.target as HTMLTextAreaElement;
        target.style.height = 'auto';
        target.style.height = `${target.scrollHeight}px`;
    }

    const isGenerateBtnDisabled = !shortName || !mccMncList.some(item => item.mcc && item.mnc);

    return (
        <CustomModal
            isOpen={isOpen}
            width={700}
            title="Add APN"
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Save APN"
            cancelButtonProps={{className: 'hide'}}
            okButtonProps={{disabled: !shortName || !apnFamily || adminStore.fullApnsList.some(item => item.shortApn == shortName)}}>
            <div className='add-apn-content'>
                <div className='name-row row'>
                    <span>APN short name:</span>
                    <input type="text" value={shortName} onChange={(e) => setShortName(e.target.value)}/>
                    {adminStore.fullApnsList.some(item => item.shortApn == shortName) && <Tooltip title='this name is already taken'><Error className='error'/></Tooltip>}
                    <span>Apn category:</span>
                    <Select options={categoryOptions}
                            value={selectedCategory}
                            onChange={setSelectedCategory}
                            className="checkbox-select"
                            style={{width: '180px'}}/>
                </div>
                <div className='table-header row'>
                    <span>MCC</span>
                    <span>MNC</span>
                    <Button type="primary"
                            onClick={() => setMccMncList([...mccMncList, {id: uuidv4(), mcc: '', mnc: ''}])}>+
                        MCC/MNC</Button>
                </div>
                {mccMncList.map((item, index) =>
                    <div className='table-row row' key={item.id}>
                        <Select options={mccOptions}
                                value={item.mcc}
                                onChange={(value) => handleMccMncChange(index, value, 'mcc')}
                                className="checkbox-select"
                                style={{width: '80px'}}/>
                        <input type="text" value={item.mnc} maxLength={3}
                               onChange={(e) => {
                                   if (/^\d*$/.test(e.target.value)) {
                                       handleMccMncChange(index, e.target.value, 'mnc');
                                   }
                               }}/>
                        <div className={`delete ${mccMncList.length > 1 ? '' : 'hidden'}`}>
                            {mccMncList.length > 1 && <Delete onClick={() => onDeleteClick(index)}/>}
                        </div>
                    </div>
                )}
                <div className='row'>
                    <Button type="primary" className='generate-btn' onClick={onGenerateClick}
                            disabled={isGenerateBtnDisabled}>Generate</Button>
                </div>
                <div className='row'>
                    APN family
                </div>
                <div className='row'>
                    <textarea className='apn-family' value={apnFamily}
                              onChange={(e) => setApnFamily(e.target.value)}
                              onInput={onApnFamilyInput}/>
                </div>
                <div className='row remark'>Add mobile Country Codes (MCC) and Mobile Network Codes (MNC) above, and
                    select <b>Generate</b>, or
                    manually key in a comma seperated list of full APN names (APN family)
                </div>
            </div>
        </CustomModal>
    );
});